import React from 'react';

import * as styled from './styles';

type Props = {
  value: number;
  size?: number;
};

export const StarDisplay = ({ value, size = 18 }: Props) => (
  <styled.Row>
    {[1, 2, 3, 4, 5].map((starValue) => (
      <styled.Star key={starValue} $filled={starValue <= Math.round(value)} $size={size}>
        ★
      </styled.Star>
    ))}
  </styled.Row>
);
